import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import api from "../../api";
import { PageTitle } from "./AdminLayout";
import { Switch } from "../../components/ui/switch";

export default function AIAdmin() {
  const [ai, setAi] = useState(null);

  const load = () => api.get("/admin/extras/ai").then((r) => setAi(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  if (!ai) return <p className="text-white/40 font-mono text-sm">Loading…</p>;

  const save = async (patch) => {
    try {
      const res = await api.put("/admin/extras/ai", patch);
      setAi(res.data);
      toast.success("AI settings saved");
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  const pct = Math.min(100, Math.round((ai.usage.requests / ai.monthly_limit) * 100));

  return (
    <div data-testid="admin-ai">
      <PageTitle title="AI Management" sub="Smart radio and recommendation features." />
      <div className="grid lg:grid-cols-2 gap-6 max-w-5xl">
        <div className="rounded-lg border border-white/5 bg-panel p-6 space-y-3" data-testid="ai-toggles">
          <p className="text-[11px] uppercase tracking-[0.18em] text-white/40 font-semibold mb-2 flex items-center gap-2"><Sparkles size={13} className="text-volt" /> Features</p>
          {[["enabled", "AI features master switch"], ["smart_radio", "Smart radio autoplay"], ["recommendations", "Playlist recommendations"]].map(([k, label]) => (
            <label key={k} className="flex items-center justify-between rounded-md border border-white/10 px-4 py-3.5 text-sm text-white/70 cursor-pointer" data-testid={`ai-toggle-${k}`}>
              {label}
              <Switch checked={!!ai[k]} onCheckedChange={(v) => save({ [k]: v })} />
            </label>
          ))}
          <div className="pt-2">
            <label className="text-xs uppercase tracking-[0.15em] text-white/50 block mb-1.5">Monthly request limit</label>
            <div className="flex gap-3">
              <input type="number" value={ai.monthly_limit} onChange={(e) => setAi({ ...ai, monthly_limit: Number(e.target.value) })} data-testid="ai-limit-input"
                className="w-40 bg-white/5 border border-white/10 rounded-md px-4 py-2.5 text-sm text-white focus:outline-none focus:ring-2 focus:ring-blurple" />
              <button onClick={() => save({ monthly_limit: ai.monthly_limit })} data-testid="ai-limit-save"
                className="bg-blurple hover:bg-[#4752c4] text-white text-sm font-semibold px-5 rounded-md transition-colors duration-150">Save</button>
            </div>
          </div>
        </div>

        <div className="rounded-lg border border-white/5 bg-panel p-6" data-testid="ai-usage">
          <p className="text-[11px] uppercase tracking-[0.18em] text-white/40 font-semibold mb-5">Usage this month</p>
          <p className="font-heading text-3xl font-bold text-white">{ai.usage.requests.toLocaleString()} <span className="text-base text-white/40 font-normal">requests</span></p>
          <p className="text-sm text-red-400/80 mt-1">{ai.usage.errors} errors</p>
          <div className="mt-5 h-2 rounded-full bg-white/10 overflow-hidden">
            <div className="h-full bg-gradient-to-r from-blurple to-volt" style={{ width: `${pct}%` }} />
          </div>
          <p className="text-xs text-white/40 font-mono mt-2">{pct}% of {ai.monthly_limit.toLocaleString()} monthly limit</p>
        </div>
      </div>
    </div>
  );
}
